import moment from 'moment';
import { humanize } from 'underscore.string';
import React from 'react';
import { Translation } from 'react-i18next';
import { sluggify } from '../../../utils/localization/utils';
import { AUTOMATED_PAYMENT_EVENTS } from 'constants/accounting';

class HistoryTable extends React.Component {
  getDescription(ev) {
    if (ev.data && ev.data.human && ev.user) {
      return (
        <Translation>
          {(t, { i18n }) => (
            <>
              {t('ACCOUNTING_AUDIT_EVENT', {
                event: ev.type && ev.type === "rpa-update" ? ev.event : t(sluggify(humanize(ev.event))),
                user: ev.user,
              })}
            </>
          )}
        </Translation>
      );
    }

    if (
      AUTOMATED_PAYMENT_EVENTS.includes(ev.event) &&
      ev?.data?.automated_payment_status_event
    ) {
      return (
        (<Translation>
          {(t) => (
            <>
              {t(sluggify(ev.event))}
              <div data-testid="div-8a1b6c65">{`${t('AMOUNT')}: ${ev?.data?.amount}`}</div>
            </>
          )}
        </Translation>)
      );
    }
    return (
      <Translation>
        {(t, { i18n }) => <>{ev.type && ev.type === "rpa-update" ? ev.event : t(sluggify(humanize(ev.event)))}</>}
      </Translation>
    );
  }

  render() {
    const events = this.props.data;
    const type = this.props.type;

    if (events.length === 0) {
      return (
        (<Translation>
          {(t, { i18n }) => (
            <h5 data-testid="h5-ee121e38" className="ml-6">{t('NO_EVENTS_RECORDED', { type })}</h5>
          )}
        </Translation>)
      );
    }

    const history = [...events].reverse().map((ev, index) => {
      return (
        (<Translation>
          {(t, { i18n }) => (
            <tr data-testid={`tr-67b9bad1-${index}`} key={ev._id}>
              <td data-testid={`td-e3fd6831-${index}`}>{this.getDescription(ev)}</td>
              <td data-testid={`td-ba7ed5ce-${index}`}>{ev.user || t('UNKNOWN_USER')}</td>
              <td data-testid={`td-a811adfb-${index}`}>{moment(ev.timestamp).format('LLLL')}</td>
            </tr>
          )}
        </Translation>)
      );
    });

    return (
      (<Translation>
        {(t, { i18n }) => (
          <div
            data-testid="div-954cad61"
            className="px-4 py-5 sm:px-6 overflow-x-scroll">
            <table data-testid="table-8b2e37d2" className="default-table">
              <thead data-testid="thead-f0114464">
                <tr data-testid="tr-7680c5bb">
                  <th data-testid="th-971a159e">{t('EVENT', { count: 1 })}</th>
                  <th data-testid="th-4b7456fd">{t('TRIGGERED_BY')}</th>
                  <th data-testid="th-279e32a3">{t('TIME')}</th>
                </tr>
              </thead>
              <tbody data-testid="tbody-e9cadd88">{history}</tbody>
            </table>
          </div>
        )}
      </Translation>)
    );
  }
}

export default HistoryTable;
